<template>
    <div v-if="showroom && isVisible">
        <div class="banner-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-lg-6" v-if="showroom.profile">
                        <div class="banner-left">
                            <div class="banner-content">
                                <div class="banner-logo" v-if="showroom && showroom.custom_addon && showroom.custom_addon.subscription_status">
                                    <a href="javascript:void(0);"  v-if="showroom.profile">
                                        <img class="banner-logo-img" :src="set_image(showroom.profile.business_logo)"  alt="">
                                    </a>
                                </div>
                                <h3 class="banner-headding">{{showroom.profile.banner_title}}</h3>
                                <p>{{showroom.profile.banner_description}}</p>
                                <ul class="banner-social list-unstyled mb-0 mt-3">
                                    <li v-if="showroom.profile && showroom.profile.facebook_link">
                                        <a :href="showroom.profile.facebook_link" target="_blank">
                                            <img src="assets/images/facebook.svg" alt="" > Facebook
                                        </a>
                                    </li>

                                    <li v-if="showroom.profile && showroom.profile.instagram_link">
                                        <a :href="showroom.profile.instagram_link"  target="_blank">
                                            <img src="assets/images/insta.svg" alt=""> Instagram
                                        </a>
                                    </li>
                                    <li v-if="showroom.profile && showroom.profile.website_link">
                                        <a :href="showroom.profile.website_link"  target="_blank">
                                            <img src="assets/images/website.png" alt=""> Website
                                        </a>
                                    </li>
                                    <li v-if="showroom.profile && showroom.profile.yelp_link">
                                        <a :href="showroom.profile.yelp_link"  target="_blank">
                                            <img src="assets/images/yelp.png" alt=""> Yelp
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="banner-gallery" v-if="showroom.profile && showroom.profile.projectsgalleries && showroom.profile.projectsgalleries.length>0">
                                <h3 class="mb-3">Gallery</h3>
                                <div class="banner-thumbnail-slider" v-if="showroom.profile.projectsgalleries">

                                    <VueSlickCarouselFinal
                                        :lazyLoad="'ondemand'"
                                        ref="c1"
                                        :asNavFor="c2"
                                        :slidesToShow=3
                                        :slidesToScroll=1
                                        :autoplay="true"
                                        :infinite="true"
                                        :dots="false"
                                        :arrows="true"
                                        :focusOnSelect="true"
                                        :centerMode="true"
                                        @beforeChange="syncSliders"

                                    >


                <div v-for="(galleries, index)  in  showroom.profile.galleries" :key="'pg'+index">
                    <div class="banner-item">
                        <div v-lazy-container="{ selector: 'img' }">
                            <img :data-src="set_image(galleries.gallery_image)" alt="" data-error="assets/images/no_image.svg" data-loading="assets/images/loading.gif" >
                        </div>
                    </div>
                </div>



                                        <template #prevArrow="arrowOption">
                                            <div class='slick-prev slick-arrow'><img src='assets/images/arrow.svg'></div>
                                        </template>

                                        <template #nextArrow="arrowOption">

                                            <div class='slick-next slick-arrow'><img src='assets/images/arrow.svg'></div>

                                        </template>
                                    </VueSlickCarouselFinal>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="banner-slider" v-if="showroom.profile.galleries">
                            <VueSlickCarouselFinal
                               :lazyLoad="'ondemand'"
                                ref="c2"
                                :asNavFor="c1"
                                :slidesToShow=1
                                :slidesToScroll=1
                                :autoplay="true"
                                :infinite="true"
                                :dots="false"
                                :arrows="true"
                                class="banner-slider"
                               @beforeChange="syncSliders"

                            >

                                <div v-for="(galleries,index)  in showroom.profile.galleries" :key="index">
                                    <div class="banner-item">
                                        <div v-lazy-container="{ selector: 'img' }">
                                            <img :data-src="set_image(galleries.gallery_image)" data-error="assets/images/no_image.svg" data-loading="assets/images/loading.gif">
                                        </div>
                                    </div>
                                </div>


                                <template #prevArrow="arrowOption">
                                    <div class='slick-prev slick-arrow'><img src='assets/images/arrow.svg'></div>
                                </template>

                                <template #nextArrow="arrowOption">

                                    <div class='slick-next slick-arrow'><img src='assets/images/arrow.svg'></div>

                                </template>
                            </VueSlickCarouselFinal>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Category Slider Start -->
        
        <vue-easy-lightbox escDisabled moveDisabled :visible="visibleLightBox" :imgs="visibleLightBoxImage"
            @hide="visibleLightBox=false"></vue-easy-lightbox>
    </div>
</template>

<script>
import VueSlickCarouselFinal from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
    components:{
        VueSlickCarouselFinal
    },
    props:['showroom',"isVisible"],

    data(){
        return{
            c1: undefined,
            c2: undefined,
            visibleLightBox: false,
            visibleLightBoxImage: '',
        }
    },

    mounted() {
        this.c1 = this.$refs.c1;
        this.c2 = this.$refs.c2;
    },
    methods:{
        ProjectLightbox(image) {
            this.visibleLightBoxImage = [{
                //title: item.designers_design.file_name,
                src: this.set_image(image)
            }]
            this.visibleLightBox = true
        },
        syncSliders(currentPosition, nextPosition) {
            this.$refs.c1.next()
            this.$refs.c2.next()
        }
    }

}
</script>
